// src/components/home/PatientBenefitsSection.js
import React from 'react';
import './PatientBenefitsSection.css';

const PatientBenefitsSection = () => {
  return (
    <section className="patient-section">
      <div className="section-container">
        

        <div className="split-container">
          {/* Phone Mockup */}
          <div className="patient-visual">
            <div className="phone-mockup">
              <div className="phone-screen">
                <div className="screen-header">📅 Book Your Planned Appointment</div>
                
                <div className="planned-info-box">
                  <div className="planned-procedure">Crown Preparation</div>
                  <div className="planned-details">60 minutes • Dr. Smith</div>
                </div>

                <div className="select-time-label">Select a time:</div>

                <div className="appointment-slot">
                  <div className="slot-time">Mon, Dec 2 • 9:00 AM</div>
                  <button className="slot-button">Book</button>
                </div>

                <div className="appointment-slot">
                  <div className="slot-time">Mon, Dec 2 • 2:00 PM</div>
                  <button className="slot-button">Book</button>
                </div>

                <div className="appointment-slot">
                  <div className="slot-time">Tue, Dec 3 • 10:30 AM</div>
                  <button className="slot-button">Book</button>
                </div>

                <div className="appointment-slot">
                  <div className="slot-time">Tue, Dec 3 • 3:00 PM</div>
                  <button className="slot-button">Book</button>
                </div>
              </div>
            </div>
          </div>

          {/* Benefits List */}
          <div>
            <ul className="patient-benefits-list">
              <li className="benefit-item">
                <div className="benefit-icon">📱</div>
                <div className="benefit-content">
                  <div className="benefit-title">Book Anytime, Anywhere</div>
                  <div className="benefit-description">
                    Patients book appointments from their phone at 11 PM on Sunday, not just during office hours. No more phone tag.
                  </div>
                </div>
              </li>

              <li className="benefit-item">
                <div className="benefit-icon">⚡</div>
                <div className="benefit-content">
                  <div className="benefit-title">See Real Availability</div>
                  <div className="benefit-description">
                    Shows actual open slots from your Open Dental schedule right now—not outdated information from 5 minutes ago.
                  </div>
                </div>
              </li>

              <li className="benefit-item">
                <div className="benefit-icon">⭐</div>
                <div className="benefit-content">
                  <div className="benefit-title">Planned Appointments Made Easy</div>
                  <div className="benefit-description">
                    If your dentist planned their crown, the system shows "Book Your Crown Preparation" with available time slots. Patient just picks a time—done.
                  </div>
                </div>
              </li>

              <li className="benefit-item">
                <div className="benefit-icon">🔄</div>
                <div className="benefit-content">
                  <div className="benefit-title">Easy Rescheduling</div>
                  <div className="benefit-description">
                    Need to move an appointment? Patients can reschedule online without calling. Less work for your front desk.
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Stats Bar */}
        <div className="stats-bar">
          <div>
            <div className="stat-number">73%</div>
            <div className="stat-label">of bookings happen after hours</div>
          </div>
          <div>
            <div className="stat-number">87%</div>
            <div className="stat-label">of patients prefer booking online</div>
          </div>
          <div>
            <div className="stat-number">40%</div>
            <div className="stat-label">more planned appointments completed</div>
          </div>
          <div>
            <div className="stat-number">5 hrs</div>
            <div className="stat-label">saved per week on phone calls</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PatientBenefitsSection;